import { FeatureToggleKey } from "@omni/types/enums/featureToggleKey.enum";
import React, { Context, use, useEffect } from "react";

import { useFeatureToggle } from "@/context/featureToggles.context";
import { useThunkDispatch } from "@/redux/dispatcher";
import { load } from "@/redux/modules/api/data/customer/customer.module";
import CallService, { CallServiceKey } from "@/services/call.service";
import { Config } from "@/utils/config.utils";

type AuthorisationContextValues = {};

type AuthorisationProviderProps = {
    children?: React.ReactNode;
};

const defaultContext: AuthorisationContextValues = {};

const AuthorisationContext: Context<AuthorisationContextValues> =
    React.createContext<AuthorisationContextValues>(defaultContext);

const AuthorisationProvider = ({ children }: AuthorisationProviderProps) => {
    const dispatch = useThunkDispatch();

    const authorisationModeEnabled = useFeatureToggle(
        FeatureToggleKey.FEATURE_AUTHORISATION_MODE
    );

    useEffect(() => {
        if (
            Config.general["authentication-required"] ||
            authorisationModeEnabled
        ) {
            CallService.enable(CallServiceKey.Customer);
            dispatch(load());
        }
    }, [authorisationModeEnabled, dispatch]);

    return <AuthorisationContext value={{}}>{children}</AuthorisationContext>;
};

const useAuthorisationContext = (): AuthorisationContextValues => {
    const context = use<AuthorisationContextValues>(AuthorisationContext);
    if (context === undefined) {
        throw new Error("No context found");
    }
    return context;
};

export { AuthorisationProvider, useAuthorisationContext };
